import { useNavigate } from 'react-router';
import styles from '../StartPage.module.scss';
import { FancyButton } from '../../../components/primitives/FancyButton';
import { useAppSelector, useUser } from '../../../app/hooks';
import { selectTemplatesAndCombinedOntology } from '../../../data/templateSlice';

interface TpDataUploadsProps {
  dashboardtemplate: any;
}

const DataUploads = (props: TpDataUploadsProps) => {
  const { dashboardtemplate } = props;
  const navigate = useNavigate();
  const { user } = useUser();
  const { uploadTemplates } = useAppSelector(selectTemplatesAndCombinedOntology);
  const uploadTemplatesToVisualize = dashboardtemplate.uploadTypes
    ? Object.values(uploadTemplates).filter((temp) => {
        return dashboardtemplate.uploadTypes.includes(temp.uploadType);
      })
    : Object.values(uploadTemplates);

  const getUploadButton = (element: any): any => {
    return (
      <FancyButton
        iconName="fad:upload"
        large={true}
        onClick={() => {
          navigate(`/upload/${element.id}`);
        }}
      >
        {element.displayName}
      </FancyButton>
    );
  };
  if (uploadTemplatesToVisualize.length > 0 && user.canWrite) {
    return (
      <>
        <div className={styles.DataUploadsWrapper}>
          {uploadTemplatesToVisualize.map((element: any, index: string) => {
            return (
              <div key={`${element.id}-${index}`} style={{ display: 'inline-block', margin: '0 20px 0 0' }}>
                {getUploadButton(element)}
              </div>
            );
          })}
        </div>
        <div key="data-uploads-separator" className={styles.separator} />
      </>
    );
  }
};

export default DataUploads;
